// dev
const baseURL = 'https://api.dev.scp.smartsys.io/core';
const baseURLBayMontioring = 'https://api.dev.scp.smartsys.io/bay-monitoring';
const env = 'dev';
const sc__utility = 'https://storage.googleapis.com/sc-neptune-dev-static-web-content/tiles/Common/sc__utility.js?ignoreCache=1';
const GOOGLE_MAP_KEY = 'AIzaSyByeXC97i8j6Ep-ANFmd0phqRLg3ImLGcg';
const CORE_END_POINT = 'https://api.dev.scp.smartsys.io/core';
const API_KEY = '22slAIAqJIbprWMZ7Do5hODNlDPlp6MA';
export { baseURL,baseURLBayMontioring, env, sc__utility, GOOGLE_MAP_KEY, CORE_END_POINT, API_KEY };